<template>
  <div class="user-wrp-comments example-full">
    <div class="result-brackter__title user__list-count">
      <div class="room-bar">
        <div class="room-number">
          <span class="result-bracket__count">{{ rooms.length }}</span> Adet Oda
          Bulunuyor
        </div>
        <div
          class="room-add"
          @click="$router.push('/yurt-yonetimi/yurtlar/odalar/ekle')"
        >
          <button class="room-add__button">
            <p class="room-add__txt">Yeni Oda Ekle</p>
            <span class="room-add__icon">
              <svg-icon type="icon-plus" />
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="dorm-room-list">
      <div
        v-for="room in rooms"
        :key="room.id"
        class="dorm-room-col col-xl-3 col-lg-3 col-md-3"
      >
        <DormRoomPanelCard
          :cover="room.dorm.cover"
          :images="room.images"
          :location="room.dorm.city.name"
          :title="room.title"
          :disabled="disabled"
          :price="room.daily_price"
          :is-active="room.is_active"
          :capacity="room.capacity"
          :meal="room.dorm.meal"
          :for-male="room.dorm.dorm_type_id === 1"
          :for-female="room.dorm.dorm_type_id === 2"
          @edit="
            () =>
              $router.push(`/yurt-yonetimi/yurtlar/odalar/${room.id}/duzenle`)
          "
          @delete="deleteRoom(room.id)"
          @reservation="
            $router.push(
              `/yurt-yonetimi/yurtlar/odalar/${room.id}/rezervasyonlar`
            )
          "
        ></DormRoomPanelCard>
      </div>
    </div>
    <p>&nbsp;</p>
  </div>
</template>

<script>
import DormRoomPanelCard from '@/components/Room/DormRoomPanelCard.vue'
import axios from 'axios'

export default {
  props: {
    rooms: {
      type: Array
    }
  },
  data() {
    return {
      disabled: false
    }
  },
  components: { DormRoomPanelCard },
  methods: {
    async deleteRoom(id) {
      this.disabled = true
      this.$loading('Siliniyor...')
      const res = await axios
        .delete(`/panel/dorm_rooms/${id}`)
        .catch(() => ({ status: 400 }))
      this.$loading.close()
      this.disabled = false
      if (res.status !== 200) {
        this.$toast.center('Bir hata oluştu.')
      } else {
        this.$toast.center('Oda başarıyla silindi.')
        this.$emit('delete', id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/components/dorm-room';
</style>
